import request from '@/api';


/**
 * 发送验证码
 */
export const sendVerificationCode = (data: any) => request.post('/user/send-verification-code', data)


/**
 * 登录注册接口
 */
export const signInUp = (data: any) => request.post('/user/signinup', data)

export const signIn = (data: any) => request.post('/user/signin', data)



export const getProfile = () => request.get('/api/v1/user/profile')